<div class="border-t border-slate-200 bg-white px-3 pb-3 pt-3 dark:border-slate-800 dark:bg-slate-950 sm:px-6">
  <div class="mx-auto max-w-4xl">
    <div class="chat-composer-surface flex items-end gap-2 rounded-xl border border-slate-300 bg-white p-2 shadow-sm transition focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/15 dark:border-slate-700 dark:bg-slate-900">
      <textarea
        #textarea
        [(ngModel)]="value"
        rows="1"
        maxlength="500"
        class="max-h-40 min-h-10 flex-1 resize-none bg-transparent px-2 py-2 text-sm leading-6 text-slate-900 outline-none placeholder:text-slate-400 dark:text-slate-100"
        [placeholder]="'askTai' | transloco"
        [attr.aria-label]="'askTai' | transloco"
        [disabled]="disabled"
        (input)="resize()"
        (keydown)="handleKeydown($event)"
      ></textarea>
      <app-knowledge-source-selector [availableSources]="availableKnowledgeSources" [selectedSources]="selectedKnowledgeSources" (selectedSourcesChange)="selectedKnowledgeSourcesChange.emit($event)" />
      <button
        type="button"
        class="chat-send grid size-10 shrink-0 place-items-center rounded-lg bg-blue-600 text-white transition hover:bg-blue-500 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:disabled:bg-slate-700 dark:disabled:text-slate-500"
        [attr.aria-label]="'sendMessage' | transloco"
        [disabled]="disabled || !value.trim()"
        (click)="submit()"
      >
        <svg aria-hidden="true" viewBox="0 0 24 24" class="size-5" fill="none" stroke="currentColor" stroke-width="2"><path d="m22 2-7 20-4-9-9-4Z" /><path d="M22 2 11 13" /></svg>
      </button>
    </div>
    <p class="mt-2 text-center text-[11px] text-slate-400 dark:text-slate-500">{{ 'disclaimer' | transloco }}</p>
  </div>
</div>
